import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState, useContext } from "react"
import { Button, message, Input, Modal } from "antd"
import { YhFormBox } from "@/erp_subpackage/components/YhFormBox"
import { formatNum } from "@/erp_subpackage/utils/util"
import { useSaleOrderDetailModel } from "./saleOrderDetailModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import useGlobalModel from "@/erp_subpackage/model/globalModel"
import { vehicleService } from "@/erp_subpackage/pages/base/vehicle/vehicleService"
import { ISalesTypeEnum, IPriceTypeEnum, IPayTypeDs } from "@/erp_subpackage/utils/ErpEnum"
import { debounce } from "lodash"
import { useSaleOrderModel } from "../../saleOrderModel"
import { MyContext } from "@/store/myContext"
import { getPcodeDict } from "@/utils/dataStorage"
import { getVehicleList } from "@/service/customerService"
import { stockDetailedService } from "@/erp_subpackage/pages/stock/detailed/stockDetailedService"
import { stockStatisticService } from "@/erp_subpackage/pages/stock/statistic/stockStatisticService"
import { getBentityListOption } from '@/utils/dataStorage'
export const FormBox = ({ modeKey, mode, rowId, dispatch }) => {
    const { t } = useTranslation();
    const { setSelectedRow } = useSaleOrderModel()
    const { getSelectedDictOne } = useDictModel()
    const {
        fetchYCCustomerList,
        user: { shopId, shopCode },
    } = useGlobalModel()
    const { detailsPage } = useContext(MyContext)
    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        vehicleEditAll,
        vehicleAddAll,
        vinEditAll,
        vinAddAll,
        initForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setVehicleAddAll,
        setVinEditAll,
        setVinAddAll,
        setVehicleEditAll,
        setDetailDataSource,
        setAddSaleType, setSaveBtnLoading, saveBtnLoading
    } = useSaleOrderDetailModel()
    const formRef = useRef()
    const [customerType, setCustomerType] = useState({})
    const [more, setMore] = useState(true) //控制更多按钮
    let { priceTypeCode, salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm
    const updateFormVal = mode === "add" ? updateAddFormVal : updatEditFormVal
    const formVal = mode === "add" ? detailAddForm : mode === "look" ? detailLookForm : detailEditForm
    useEffect(() => {
        if (mode === "edit" || mode === "look") {
            getDetailEditOne(rowId, mode).then((res) => {
                if (res.orderSourceCode === "order-source.add") {
                    getVehicleAllList(res.customerName)
                } else {
                    getYCVehicleAllList({ customerName: res.customerName })
                }
            })
        }

        // 销毁的时候触发
        return () => {
            updateFormVal(null)
            mode === "add" ? setDetailAddList([]) : setDetailDataSource([])
        }
    }, [rowId, mode])

    useEffect(() => {
        let obj = {}
        getPcodeDict("017").children.forEach((item) => {
            obj[item.dictCode] = item.title
        })
        setCustomerType(obj)
    }, [])

    const save = () => {
        formRef.current.validateFields().then(async (res) => {
            let goods = mode === 'add' ? detailAddList : detailDataSource
            if (goods.length == 0) {
                message.warning(t(`sale.details.FormBox.未添加商品明细不可生成销售订单`))
                return
            }
            if (res.settlementPartyCode === "settle-party.internal" && !!!res.note) {
                message.warning(t(`sale.details.FormBox.结算方为部门内部费用时，备注为必填项，请补齐表单里的备注项`))
                return false
            }
            if (res.salesTypeCode === ISalesTypeEnum.GIVE && !!!res.note) {
                message.warning(t(`sale.details.FormBox.销售类型为赠送服务时，备注为必填项，请补齐表单里的备注项`))
                return false
            }
            if (mode === "add") {
                const resData = await insertDetail(res)
                if (resData) {
                    message.success(`${t(`sale.details.FormBox.新增成功`)}!`)
                    resetAddCatch(mode)
                    setSelectedRow([resData])
                    goBack()
                }
            } else if (mode === "edit") {
                let { id, saleOrderCode } = detailEditForm
                const resData = await editDetail({ ...res, id, saleOrderCode })
                if (resData) {
                    message.success(`${t(`sale.details.FormBox.编辑成功`)} !`)
                    getDetailEditOne(saleOrderCode, mode)
                }
            }
        })
    }
    const goBack = () => {
        dispatch({
            type: "removeTabs",
            targetKey: modeKey,
            activeMenu: "saleOrder",
        })
        mode === "add" ? setDetailAddList([]) : setDetailDataSource([])
    }
    const onRefresh = async () => {
        if (mode === "add") {
            formRef.current.resetFields()
            getVehicleAllList()
            setDetailAddForm(initForm)
            setDetailAddList([])
            setAddSaleType(ISalesTypeEnum.WEICHAI)
        } else if (mode === "edit") {
            getDetailEditOne(rowId, mode)
        }
        message.success(t(`sale.details.FormBox.刷新成功`))
    }
    const onDiscount = () => {
        let discountVal = ""
        Modal.confirm({
            width: 380,
            title: t(`sale.details.FormBox.折扣`),
            // type: "info",
            // text: "",
            content: (
                <>
                    <span> {t(`sale.details.FormBox.请输入折扣系数`)}</span>
                    <Input
                        onChange={(e) => {
                            discountVal = e.target.value
                        }}
                        suffix="%"
                    />
                </>
            ),
            okText: t(`sale.details.FormBox.确定`),
            onOk: () => {
                var re = /^[0-9]+.?[0-9]*$/
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject(t(`sale.details.FormBox.输入的值不是数字，请重新输入`))
                        message.error(t(`sale.details.FormBox.输入的值不是数字，请重新输入`))
                    } else {
                        resolve(discountVal)
                    }
                }).then((res) => {
                    onSetDetailsTableDiscount(+discountVal)
                })
            },
            cancelText: t(`sale.details.FormBox.取消`),
            onCancel: () => { },
        })
    }
    const onSetDetailsTableDiscount = async (discount) => {
        let detailsList = mode === "add" ? detailAddList : detailDataSource
        let newDetailsList = detailsList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                amount: +formatNum((Number(item.notAmount) * discount) / 100),
            }
        })
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList)
    }
    const rightChildren = (
        <>
            {mode !== "look" && (
                <Button className="btn-item" type="link" shape="round" disabled={formVal.orderSourceCode != DictCodeEnmu.SOURCE_ADD} onClick={onDiscount}>
                    {t(`sale.details.FormBox.快捷折扣`)}
                </Button>
            )}
            {mode !== "look" && (
                <Button
                    className="btn-item"
                    type="link"
                    shape="round"
                    loading={saveBtnLoading}
                    disabled={formVal.orderSourceCode !== DictCodeEnmu.SOURCE_ADD && mode === 'edit'}
                    onClick={debounce(() => {
                        save()
                    }, 900)}
                >
                    {saveBtnLoading ? t(`sale.details.FormBox.保存中`) : t(`sale.details.FormBox.保存`)}
                </Button>
            )}
            {mode !== "look" && (
                <Button className="btn-item" type="link" shape="round" onClick={onRefresh}>
                    {t(`sale.details.FormBox.刷新`)}
                </Button>
            )}
            <Button className="btn-item" type="link" shape="round" onClick={goBack}>
                {t(`sale.details.FormBox.返回`)}
            </Button>
        </>
    )

    //车辆类型
    const vehicleTypeChange = (value, option) => {
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value })
    }
    //维修类型
    const maintenanceTypeChange = (value, option) => {
        option && onChange({ maintenanceTypeName: option.label, maintenanceTypeCode: option.value })
    }
    //结算方
    const settlementPartyChange = (value, option) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value })
    }
    //客户类型
    const customerTypeChange = (value, option) => {
        option && onChange({ customerTypeName: option.label, customerTypeCode: option.value })
    }
    //发票类型
    const invoiceTypeChange = (value, option) => {
        option && onChange({ invoiceTypeName: option.label, invoiceTypeCode: option.value })
    }
    //销售类型
    const salesTypeChange = (value, option) => {
        option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: undefined, priceTypeCode: undefined })
        if (value === ISalesTypeEnum.NORMAL_SALES) {
            option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: t(`sale.details.FormBox.零售价`), priceTypeCode: "price-selection.retail" })
        }
        if (!value) {
            onChange({ salesTypeName: undefined, salesTypeCode: undefined, priceTypeName: undefined, priceTypeCode: undefined })
        }
        if (value) {
            alterListPrice(value === ISalesTypeEnum.NORMAL_SALES ? "price-selection.retail" : undefined, value, customerCode)
        }
    }

    //售价选择
    const priceTypeChange = (value, option) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value })
        if (value) {
            alterListPrice(value, salesTypeCode, customerCode)
        }
    }
    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode, salesTypeCode, customerCode) => {
        let detailsList = mode == "add" ? detailAddList : detailDataSource
        if (!detailsList.length) return;
        if (!salesTypeCode || !customerCode) {
            message.warning(t(`sale.details.FormBox.请补全客户名称，销售类型才可以，对下列表格的价格数据进行更改`))
            return false
        }
        let newDetailsList = await Promise.all(detailsList.map(async item => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, decreaseAmount, retailPrice, num, ...params } = item;
            let newPrice = 0;
            if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await stockDetailedService.recentSalesPrice(shopId, materialCode, customerCode);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = await findPoDetailPrice(stockId, ["retailPrice"])
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["petroleumPrice", "purchasePrice"], true);
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }
            return {
                ...item,
                num,
                price: newPrice,
                notAmount: +formatNum(num * newPrice),
                amount: +formatNum((num * newPrice * discountRate) / 100)
            }
        }))
        // console.log(newDetailsList)
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList);
    }
    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId, priceType, priceTypeLen) => {
        let resultPrice = 0
        try {
            let { retData } = await stockStatisticService.findId(stockId)
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]]
        } catch (e) { }
        return resultPrice
    }

    // 来源为新增时车辆数据为云修
    const getVehicleAllList = async (param) => {
        let params = {
            ...param,
            shopId,
            pageSize: -1,
            pageNum: 1,
        }
        const { retData } = await vehicleService.page(params)
        const { records } = retData
        let newRecords = records.map((item) => {
            return {
                // ...item,
                label: item.licensePlate,
                value: item.licensePlate,
                vehicle_type_code: item.categoryCode,
                vehicle_type_name: item.categoryName,
                customer_code: item.code,
                customer_name: item.customerName,
                vin: item.vin,
                vehicle_model: item.model,
                license_plate: item.licensePlate,
                phone: item.phone,
                contact: item.contact,
                address: item.address,
                customer_type_code: item.typeCode,
                customer_type_name: item.typeName,
            }
        })

        let vinRecords = records.map((item) => {
            return {
                label: item.vin,
                value: item.vin,
                license_plate: item.licensePlate,
                vehicle_model: item.model,
                vehicle_type_code: item.categoryCode,
                vehicle_type_name: item.categoryName,
                customer_code: item.code,
                customer_name: item.customerName,
                vin: item.vin,
                phone: item.phone,
                contact: item.contact,
                address: item.address,
                customer_type_code: item.typeCode,
                customer_type_name: item.typeName,
            }
        })
        if (mode === "add") {
            setVehicleAddAll(newRecords)
            setVinAddAll(vinRecords)
        } else {
            setVehicleEditAll(newRecords)
            setVinEditAll(vinRecords)
        }
    }

    // 来源为小程序或者App时  车辆来源为云创本身的数据
    const getYCVehicleAllList = async (param) => {
        let data = {
            searchItem: {
                ...param,
            },
            pageSize: -1,
            pageNum: 1,
        }
        getVehicleList(data).then((res) => {
            const {
                retData: { list },
            } = res
            console.log(t(`sale.details.FormBox.云创`), list)
            let newRecords = list.map((item) => {
                return {
                    label: item.vehicleCode,
                    value: item.vehicleCode,
                    vehicle_type_name: item.vehicleType,
                    customer_name: item.customerName,
                    customer_code: item.customerId,
                    vin: item.vehicleVin,
                    license_plate: item.vehicleCode,
                }
            })
            let vinRecords = list.map((item) => {
                return {
                    label: item.vehicleVin,
                    value: item.vehicleVin,
                    vehicle_type_name: item.vehicleType,
                    customer_name: item.customerName,
                    customer_code: item.customerId,
                    license_plate: item.vehicleCode,
                    vin: item.vehicleVin,
                }
            })
            if (mode === "add") {
                setVehicleAddAll(newRecords)
                setVinAddAll(vinRecords)
            } else {
                setVehicleEditAll(newRecords)
                setVinEditAll(vinRecords)
            }
        })
    }
    //客户名称
    const customerChange = (value, option) => {
        console.log(option)
        if (value && option) {
            let { contact, phone, address, category_name, category_code } = option
            option &&
                updateFormVal({
                    customerName: option.label,
                    customerCode: option.value,
                    contact,
                    phone,
                    address,
                    customerTypeCode: category_code,
                    customerTypeName: category_name ?? customerType[category_code],
                    licensePlate: null,
                    vehicleTypeCode: null,
                    vehicleTypeName: null,
                    vin: null,
                })
        }
        formVal.orderSourceCode === DictCodeEnmu.SOURCE_ADD
            ? getVehicleAllList({ customerName: option?.label })
            : getYCVehicleAllList({ customerName: option?.label })
    }
    const bentityChange = (value, option) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value })
    }
    //车辆牌照
    const vehicleChange = (value, option) => {
        console.log(option)
        if (value && option) {
            let {
                customer_code,
                customer_name,
                vehicle_model,
                vehicle_type_name,
                vehicle_type_code,
                vin,
                phone,
                address,
                contact,
                customer_type_code,
                customer_type_Name,
            } = option
            option &&
                updateFormVal({
                    customerName: customer_name,
                    customerCode: customer_code,
                    vin,
                    licensePlate: option.value,
                    vehicleTypeCode: vehicle_type_code ?? "",
                    vehicleTypeName: vehicle_type_name ?? "",
                    vehicleModel: vehicle_model,
                    phone: phone ?? formVal.phone,
                    address: address ?? formVal.address,
                    contact: contact ?? formVal.contact,
                    customerTypeCode: customer_type_code ?? formVal.customerTypeCode,
                    customerTypeName: customer_type_Name ?? formVal.customerTypeName,
                })
        }
    }
    //vin码
    const vinChange = (value, option) => {
        if (value && option) {
            let {
                customer_code,
                customer_name,
                vehicle_model,
                license_plate,
                vehicle_type_name,
                vehicle_type_code,
                vin,
                phone,
                address,
                contact,
                customer_type_code,
                customer_type_Name,
            } = option
            option &&
                onChange({
                    customerName: customer_name,
                    customerCode: customer_code,
                    vin,
                    licensePlate: license_plate,
                    vehicleTypeCode: vehicle_type_code ?? "",
                    vehicleTypeName: vehicle_type_name ?? "",
                    vehicleModel: vehicle_model,
                    phone: phone ?? formVal.phone,
                    address: address ?? formVal.address,
                    contact: contact ?? formVal.contact,
                    customerTypeCode: customer_type_code ?? formVal.customerTypeCode,
                    customerTypeName: customer_type_Name ?? formVal.customerTypeName,
                })
        }
    }
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm,
    }
    const goCustomer = () => {
        // if (formVal.orderSourceCode === DictCodeEnmu.SOURCE_ADD) {
        //     dispatch({
        //         type: "changeTabs",
        //         name: "客户新增",
        //         activeMenu: "baseCustomer/add",
        //         content: detailsPage.BaseCustomerDetails({
        //             dispatch,
        //             modeKey,
        //             mode,
        //         }),
        //     })
        // } else {
        dispatch({
            type: "changeTabs",
            name: t(`sale.details.FormBox.客户新增`),
            activeMenu: "clientRecord/insert",
            content: detailsPage.ClientDetails({
                dispatch,
                modeKey,
                mode: "insert",
                rowInfo: {},
            }),
        })
        // }
    }
    const goVehicle = () => {
        if (formVal.orderSourceCode === DictCodeEnmu.SOURCE_Add) {
            dispatch({
                type: "changeTabs",
                name: t(`sale.details.FormBox.车辆新增`),
                activeMenu: "baseVehicle/add",
                content: detailsPage.BaseVehicleDetails({
                    dispatch,
                    modeKey,
                    mode,
                    customerCode: formVal.customerCode,
                    customerName: formVal.customerName,
                }),
            })
        } else {
            dispatch({
                type: "changeTabs",
                name: t(`sale.details.FormBox.车辆新增`),
                activeMenu: "vehicleRecord/insert",
                content: detailsPage.VehicleDetails({
                    dispatch,
                    modeKey,
                    mode: "insert",
                    rowInfo: {},
                }),
            })
        }
    }
    const [payTypeList, setPayTypeList] = useState([])
    useEffect(() => {
        if (shopCode == 'SHOP-M-00000016' || shopCode == 'SHOP-M-00000017' || shopCode == 'SHOP-M-00000018') {
            setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE))
        } else {
            setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE).map((item) => {
                return { ...item, disabled: item.value == 'settle-type.credit' ? true : false }
            }))
        }
    }, [])
    const baseFormItem = {
        title: t(`sale.details.FormBox.基础信息`),
        style: { padding: "0 20px", marginBottom: "10px" },
        contentClass: "pr-77",
        rightChildren,
        items: [
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.销售订单号`),
                fieldName: "saleOrderCode",
                disable: true,
                placeholder: t(`sale.details.FormBox.自动生成`),
            },
            {
                type: "AsyncSelect",
                fieldLabel: (
                    <span className="click-span" onClick={goCustomer}>
                        {t(`sale.details.FormBox.客户名称`)}
                    </span>
                ),
                fieldName: "customerName",
                // fieldName: "customerCode",
                allowClear: true,
                showSearch: true,
                onSelectChange: customerChange,
                selectfetchList: fetchYCCustomerList,
                defaultQuery: formVal.customerName,
                rules: [{ required: true, message: t(`sale.details.FormBox.请选择客户名称`) }],
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.联系人`),
                fieldName: "contact",
                rules: [{ required: true, message: t(`sale.details.FormBox.请输入联系人`) }],
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.联系电话`),
                fieldName: "phone",
                rules: [{ required: true, message: t(`sale.details.FormBox.请输入联系电话`) }],
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.销售类型`),
                fieldName: "salesTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.SALE_TYPE),
                onSelectChange: salesTypeChange,
                // disable: mode !== "add" ? true : false,
                rules: [{ required: true, message: t(`sale.details.FormBox.请选择销售类型`) }],
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.售价选择`),
                fieldName: "priceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
                onSelectChange: priceTypeChange,
                disable: salesTypeCode !== ISalesTypeEnum.NORMAL_SALES || (formVal.status !== DictCodeEnmu.SALE_ORDER_CREATE && mode === 'edit'), // mode !== "add" ? true : addSaleType !== ISalesTypeEnum.NORMAL_SALES,
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.结算方`),
                fieldName: "settlementPartyCode",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                rules: [{ required: true, message: t(`sale.details.FormBox.请选择结算方`) }],
                hidden: mode === "look",
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.结算方`),
                fieldName: "settlementPartyName",
                hidden: mode !== "look",
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.结算类型`),
                fieldName: "payType",
                // options: formVal.orderSourceCode === DictCodeEnmu.SOURCE_ADD ? getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE) : IPayTypeDs,
                options: formVal.orderSourceCode === DictCodeEnmu.SOURCE_ADD ? payTypeList : IPayTypeDs,
                rules: [{ required: true, message: t(`sale.details.FormBox.请选择结算类型`) }],
            },
            // {
            //     type: "Select",
            //     fieldLabel: t(`sale.details.FormBox.销售实体`),
            //     fieldName: "bentityCode",
            //     options: getBentityListOption(),
            //     onSelectChange: bentityChange,
            //     rules: [{ required: true, message: t(`sale.details.FormBox.请选择销售实体`) }],
            // },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.备注`),
                fieldName: "note",
                span: 12,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.客户地址`),
                fieldName: "address",
                span: 5,
            },
            {
                type: "Button",
                fieldLabel: (
                    <a className="color-blue text-line" onClick={() => setMore(!more)}>
                        {more ? `${t(`sale.details.FormBox.更多`)}` : t(`sale.details.FormBox.隐藏`)}
                    </a>
                ),
                fieldName: "none",
                span: 1,
            },
            {
                type: "Input",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.客户类型`),
                // fieldName: "customerTypeCode",
                fieldName: "customerTypeName",
                // options: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE),
                onSelectChange: customerTypeChange,
                disable: true,
                hidden: more,
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.发票类型`),
                fieldName: "invoiceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
                onSelectChange: invoiceTypeChange,
                hidden: more,
            },
            {
                type: "Select",
                allowClear: true,
                showSearch: true,
                fieldLabel: t(`sale.details.FormBox.车辆类型`),
                fieldName: "vehicleTypeName",
                disable: true,
                // fieldName: "vehicleTypeCode",
                // options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                onSelectChange: vehicleTypeChange,
                hidden: more,
            },
            {
                type: "Select",
                fieldLabel: (
                    <span className="click-span" onClick={goVehicle}>
                        {t(`sale.details.FormBox.车辆牌照`)}
                    </span>
                ),
                fieldName: "licensePlate",
                allowClear: true,
                showSearch: true,
                options: mode === "add" ? vehicleAddAll : vehicleEditAll,
                onSelectChange: vehicleChange,
                hidden: more,
            },
            {
                type: "Select",
                fieldLabel: `VIN${t(`sale.details.FormBox.码`)}`,
                fieldName: "vin",
                allowClear: true,
                showSearch: true,
                onSelectChange: vinChange,
                options: mode === "add" ? vinAddAll : vinEditAll,
                hidden: more,
            },
            {
                type: "Select",
                fieldLabel: t(`sale.details.FormBox.订单来源`),
                fieldName: "orderSourceCode",
                options: getSelectedDictOne(DictCodeEnmu.ORDER_SOURCE),
                // hidden: more,
                hidden: true,
                disable: true,
                rules: [{ required: true, message: t(`sale.details.FormBox.请选择订单来源`) }],
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.订单来源`),
                fieldName: "orderSourceName",
                // hidden: true,
                hidden: more,
                disable: true,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.所属机构`),
                fieldName: "shopName",
                disable: true,
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.制单人`),
                fieldName: "createUser",
                disable: true,
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.制单时间`),
                fieldName: "createTime",
                disable: true,
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.收货人`),
                fieldName: "consignee",
                disable: mode != 'edit' || (formVal.status !== DictCodeEnmu.SALE_ORDER_CREATE && mode === 'edit'),
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.收货电话`),
                fieldName: "consigneePhone",
                disable: mode != 'edit' || (formVal.status !== DictCodeEnmu.SALE_ORDER_CREATE && mode === 'edit'),
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.收货地址`),
                fieldName: "consigneeAddress",
                disable: mode != 'edit' || (formVal.status !== DictCodeEnmu.SALE_ORDER_CREATE && mode === 'edit'),
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.单据编号`),
                fieldName: "orderCode",
                disable: true,
                hidden: more,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.单据类型`),
                fieldName: "orderTypeName",
                disable: true,
                hidden: more,
            },
            // {
            //     type: "Select",
            //     fieldLabel: "单据类型",
            //     fieldName: "orderTypeCode",
            //     options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE),
            //     hidden: more,
            //     disable: true,
            // },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.付款时间`),
                fieldName: "payTime",
                disable: true,
                hidden: more,
            },

            //带出字段
            // {
            //     type: "Input",
            //     fieldLabel: t(`sale.details.FormBox.销售实体名称`),
            //     fieldName: "bentityName",
            //     hidden: true,
            // },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.客户名称`),
                fieldName: "customerCode",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.车辆类型`)}Name`,
                fieldName: "vehicleTypeCode",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.维修类型`)}Name`,
                fieldName: "maintenanceTypeName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.结算方`)}Name`,
                fieldName: "settlementPartyName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.结算方式`)}Name`,
                fieldName: "paymentMethodName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.客户类型`)}Name`,
                fieldName: "customerTypeCode",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.发票类型`)} Name`,
                fieldName: "invoiceTypeName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.车辆里程`),
                fieldName: "mileage",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.车辆型号`),
                fieldName: "vehicleModel",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.售价选择`)}Name`,
                fieldName: "priceTypeName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: t(`sale.details.FormBox.销售类型`),
                fieldName: "salesTypeName",
                hidden: true,
            },
            // {
            //     type: "Input",
            //     fieldLabel: "订单来源name",
            //     fieldName: "orderSourceName",
            //     hidden: true,
            // },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.支付方式`)} Name`,
                fieldName: "payMethodName",
                hidden: true,
            },
            {
                type: "Input",
                fieldLabel: `${t(`sale.details.FormBox.单据类型`)}Name`,
                fieldName: "orderTypeName",
                hidden: true,
            },
            {
                type: 'Input',
                fieldLabel: t(`sale.details.FormBox.采购实体名称`),
                fieldName: 'bentityName',
                hidden: true,
            },
        ],
    }

    const onChange = (changedValues) => {
        mode === "add" ? updateAddFormVal(changedValues) : updatEditFormVal(changedValues)
    }
    const poFromConfig = {
        formRef,
        disabled: mode === "look" || formVal.orderSourceCode !== DictCodeEnmu.SOURCE_ADD || formVal.status === DictCodeEnmu.SALE_ORDER_SETTLE,
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem],
    }

    return <YhFormBox {...poFromConfig} />
}
